import * as React from "react";
import { useModalStore } from "../lib/store/useModalStore";
import { useMyInfoStore } from "../lib/store/useMyInfoStore";
import { useMarketingFlowStore } from "../lib/store/useMarketingFlowStore";

export function useMarketingPopupConfirm() {
  const { myInfo, setMyInfo } = useMyInfoStore();
  const { modals, openModal } = useModalStore();
  const consumeAfterClose = useMarketingFlowStore((s) => s.consumeAfterClose);
  const openedRef = React.useRef(false);

  React.useEffect(() => {
    if (!myInfo.isMarketingPopupOpen) {
      openedRef.current = false;
      return;
    }

    if (openedRef.current) return;
    if (modals.some(({ key }) => key === "MARKETING_AGREEMENT_DIALOG")) return;
    openedRef.current = true;

    openModal("MARKETING_AGREEMENT_DIALOG", {
      onAgree: () => {
        setMyInfo({ isMarketingPopupOpen: false });
        consumeAfterClose();
      },
      onLater: () => {
        setMyInfo({ isMarketingPopupOpen: false });
        consumeAfterClose();
      },
    });
  }, [modals, myInfo.isMarketingPopupOpen, openModal, setMyInfo, consumeAfterClose]);
}
